import React, { useState, useEffect } from "react";
import { Breadcrumb } from "rbx";
import { useLocation, Link } from "react-router-dom";

import { startCase, upperCase } from "lodash";

const BreadCrumbs = () => {
  const location = useLocation();

  const [crumbs, setCrumbs] = useState([]);

  useEffect(() => {
    const getCrumbs = () =>
      location.pathname
        .split("/")
        .filter(x => x.length)
        // filter out rec ids from breadcrumb links --> replace with meaningful value at a later date
        .filter(x => !Number.isInteger(parseInt(x)));
    setCrumbs(getCrumbs());
  }, [location.pathname]);

  return (
    <Breadcrumb>
      <Breadcrumb.Item as={Link} key="home" tabIndex="-1" to="/">
        Home
      </Breadcrumb.Item>
      {crumbs.map((crumb, index) => (
        <Breadcrumb.Item
          active={index === crumbs.length - 1}
          as={Link}
          key={index}
          tabIndex="-1"
          to={`/${crumbs.slice(0, index + 1).join("/")}`}
        >
          {crumb.length < 3 ? upperCase(crumb) : startCase(crumb)}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default BreadCrumbs;
